export const productListFields = [
  {
    key: 'checkbox',
    label: '',
    thClass: 'text-black py-1',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'text-black py-1 min-w-[250px]',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
  {
    key: 'variant',
    label: 'Variasi',
    thClass: 'text-black py-1 min-w-[200px]',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
  {
    key: 'stock',
    label: 'Stok',
    thClass: 'text-black py-1',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
  {
    key: 'total',
    label: 'Jumlah Pengajuan',
    thClass: 'text-black py-1',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
  {
    key: 'pengeluaran_cost',
    label: 'Biaya Penarikan',
    thClass: 'text-black py-1',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
]

export const selectedProductFields = [
  {
    key: 'product_name',
    label: 'Nama Produk',
    thClass: 'text-black py-1',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
  {
    key: 'variants',
    label: 'Variasi',
    thClass: 'text-black py-1',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
  {
    key: 'stock',
    label: 'Stok',
    thClass: 'text-black py-1',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
  {
    key: 'total',
    label: 'Jumlah Pengajuan',
    thClass: 'text-black py-1',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
  {
    key: 'pengeluaran_cost',
    label: 'Biaya Penarikan',
    thClass: 'text-black py-1',
    thStyle: {
      fontSize: '14px',
      color: 'black',
      textTransform: 'capitalize',
    },
    tdClass: 'text-black',
  },
]
